"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntercomTicketBank = void 0;
const AbstractBatcherBank_1 = require("./base/AbstractBatcherBank");
const IntercomTicketModel_1 = require("../models/IntercomTicketModel");
const async_1 = require("async");
class IntercomTicketBank extends AbstractBatcherBank_1.AbstractBatcherBank {
    constructor(options2) {
        super(options2);
        this.options2 = options2;
        this.client = this.options2.clients.provisionIntercomClient();
    }
    generate(data) {
        return new IntercomTicketModel_1.IntercomTicketModel({
            banks: this.options2.banks(),
            clients: this.options2.clients,
            ticket: data
        });
    }
    async fetchCollection(event) {
        await (0, async_1.parallelLimit)(event.items.map((i) => {
            return async () => {
                try {
                    let ticket = await this.client.getTicket(i);
                    event.apply({
                        [this.generateID(i)]: ticket
                    });
                }
                catch (ex) {
                    event.notFound(this.generateID(i));
                }
            };
        }), 5);
    }
    generateIDFromData(data) {
        return this.generateID(data);
    }
    generateID(id) {
        return `${id.org_id}:${id.id}`;
    }
    patch(event) {
        event.object.options.ticket = event.data;
    }
}
exports.IntercomTicketBank = IntercomTicketBank;
